import React from 'react';
import TableTop from '../../../../core/table/TableTop';
import TableBody from '../../../../core/table/TableBody';
import TableHead from '../../../../core/table/TableHead';
import TablePaging from '../../../../core/table/TablePaging';
import TableExceedsDataSizeMessage from '../../../../core/table/TableExceedsDataSizeMessage';
import TableList from '../../../../core/table/TableList';
import SaveToExcelButton from '../../../../core/table/actions/SaveToExcelButton';
import HelpButton from '../../../../core/components/HelpButton';
import { useSplitOrderInvoicesListTableInit } from './useSplitOrderInvoicesListTableInit';
import { useSplitOrderInvoicesListTableState } from './useSplitOrderInvoicesListTableState';
import { useSplitOrderInvoicesData } from './useSplitOrderInvoicesData';
import { useSplitOrderInvoicesStore } from '../pagehooks/useSplitOrderInvoicesStore';
import splitOrderInvoicesRepo from '../../data/splitOrderInvoicesRepo';
import { SPLIT_ORDER_INVOICES_LIST_EXCEL_FILE_NAME } from '../../split_order_invoices_const';
import { useSplitOrderInvoicesSearchState } from '../search/useSplitOrderInvoicesSearchState';
import { HttpErrorIgnore } from '../../../../../global';
import { SplitOrderInvoicesSearchModel } from '../search/split_order_invoices_search_types';

const splitOrderInvoicesListTableId = 'splitOrderInvoicesList';

const onGetExcel = async (params: SplitOrderInvoicesSearchModel): Promise<HttpErrorIgnore | undefined> => {
    await splitOrderInvoicesRepo.excelExport(params, SPLIT_ORDER_INVOICES_LIST_EXCEL_FILE_NAME);
    return undefined;
};

type SplitOrderInvoicesListTableProps = {
    onClick?: (row: any) => void;
};

const SplitOrderInvoicesListTable = ({ onClick }: SplitOrderInvoicesListTableProps): JSX.Element => {
    const { init } = useSplitOrderInvoicesListTableInit();
    if (init) {
        return <></>;
    }

    return <TableWrapper onClick={onClick} />;
};

const TableWrapper = ({ onClick }: SplitOrderInvoicesListTableProps): JSX.Element => {
    const { action, loading, showHelp } = useSplitOrderInvoicesStore();
    const { fltStats, paging, cols, sections, sort, filters, setFilter, setSort, setPaging, waiting, setWait } =
        useSplitOrderInvoicesListTableState();
    const { items, rawDataSize } = useSplitOrderInvoicesData();
    const { state } = useSplitOrderInvoicesSearchState();

    if (action !== 'LIST' || loading) {
        return <></>;
    }

    return (
        <TableList>
            <TableExceedsDataSizeMessage dataSize={rawDataSize} />
            <TableTop
                id={splitOrderInvoicesListTableId}
                fltStats={fltStats}
                topRight={
                    <div>
                        <SaveToExcelButton
                            waiting={waiting}
                            setWait={setWait}
                            onGetExcel={() => onGetExcel(state)}
                        />
                        <HelpButton onClick={showHelp} />
                    </div>
                }
            />
            <table>
                <TableHead
                    cols={cols}
                    sections={sections}
                    sort={sort}
                    filters={filters}
                    setFilter={setFilter}
                    setSort={setSort}
                />
                <TableBody
                    cols={cols}
                    rows={items}
                    onClick={onClick}
                />
            </table>
            <TablePaging
                paging={paging}
                setPaging={setPaging}
                fltStats={fltStats}
            />
        </TableList>
    );
};

export default SplitOrderInvoicesListTable;
